import { render, staticRenderFns } from "./bind-tel-dialog.vue?vue&type=template&id=62a7da10&scoped=true&"
import script from "./bind-tel-dialog.vue?vue&type=script&lang=js&"
export * from "./bind-tel-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bind-tel-dialog.vue?vue&type=style&index=0&id=62a7da10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a7da10",
  null
  
)

export default component.exports